import React from 'react'
import { Box, Typography, withStyles } from '@material-ui/core'
import { modalTitleStyles } from 'asterX-UI/Modals/modals.styles'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import { IconCloseButton } from 'asterX-UI/Buttons'
import PropTypes from 'prop-types'
import { MODAL_STYLES } from 'asterX-UI/theme.constant'
import InfoOctagonIcon from 'asterX-UI/Icons/InfoOctagonIcon'
import { AlertOctagonIcon } from 'asterX-UI/Icons'

const ModalTitle = withStyles(modalTitleStyles)(props => {
  const { children, variant, classes, onClose, disableBtn = false, ...other } = props

  const getIconComponent = () => {
    const [info, warning, error, success] = MODAL_STYLES.variant
    if (variant === info) {
      return <InfoOctagonIcon />
    }
    if (variant === warning) {
      return <AlertOctagonIcon />
    }
    if (variant === error) {
      return <InfoOctagonIcon />
    }
    if (variant === success) {
      return <AlertOctagonIcon />
    }
    return <></>
  }

  return (
    <MuiDialogTitle
      disableTypography
      className={classes.root}
      {...other}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <Box style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        {getIconComponent()}
        <Typography variant={'subtitle2'}>{children}</Typography>
      </Box>
      {onClose
        ? !disableBtn && <IconCloseButton aria-label="close" className={classes.closeButton} onClick={onClose} />
        : null}
    </MuiDialogTitle>
  )
})
export default ModalTitle
ModalTitle.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.any,
  disableBtn: PropTypes.bool
}
